<script setup>

import {useUserStore} from "@/stores/user.store";
import {useAuthStore} from "@/stores/auth.store";
import {storeToRefs} from "pinia";

const authStore = useAuthStore();
const userStore = useUserStore();
userStore.fetchUser();
const {user} = storeToRefs(userStore);
</script>

<template>
    <van-space direction="vertical" fill>
        <van-grid clickable square>
            <van-grid-item icon="todo-list-o" text="Sessions" to="/session/list"/>
            <van-grid-item icon="orders-o" text="Forms" to="/form/list"/>
            <van-grid-item icon="video-o" text="Exercises" to="/exercise/list"/>
<!--            <van-grid-item icon="records-o" text="Surveys" to="/survey/list"/>-->
            <van-grid-item icon="records-o" text="Report" to="/report/list"/>
            <van-grid-item icon="link-o" text="Files" to="/file/list"/>
            <van-grid-item icon="comment-o" text="Instructions" to="/instruction/list"/>
            <van-grid-item icon="phone-o" text="Connects" to="/connect/list"/>
            <van-grid-item icon="friends-o" text="Advocates" to="/advocate/list"/>
        </van-grid>

        <van-row justify="center">
            <b>My Purchase Orders</b>
        </van-row>
        <van-grid clickable square>
            <van-grid-item icon="shopping-cart-o" text="All" to="/order/list/all"/>
            <van-grid-item icon="cart-o" text="Pending" to="/order/list/pending"/>
            <van-grid-item icon="cart-circle-o" text="Completed" to="/order/list/completed"/>
            <van-grid-item icon="underway-o" text="Expired" to="/order/list/expired"/>
        </van-grid>

        <van-row justify="center">
            <b>Personal Information</b>
        </van-row>
        <van-cell-group inset>
            <van-cell icon="contact" :value="user.full_name" is-link to="/account/name"/>
            <van-cell icon="envelop-o" :value="user.username" is-link to="/account/email/"/>
            <van-cell icon="revoke" value="Reset Password" is-link to="/account/password/"/>
            <van-cell icon="underway-o" :value="user?.timezone?.name" is-link to="/account/timezone/"/>
            <van-cell icon="completed-o" value="My Goals" is-link to="/goal/list"/>
            <van-cell icon="calendar-o" value="My POAPs" is-link to="/poap/list"/>
            <van-cell icon="setting-o" value="Setting" is-link to="/setting/list"/>
        </van-cell-group>

        <van-row justify="center">
            <b>Treatment Information</b>
        </van-row>
        <van-cell-group inset>
            <van-cell title="Clinic" :value="user.patient_account ? user.patient_account.name : 'N/A'"/>
            <van-cell title="Registered" :value="user.created_at_formatted"/>
            <van-cell title="Counselor" :value="user.staff"/>
            <van-cell title="Sober At" :value="user.sober_at_formatted ? user.sober_at_formatted : 'N/A'"/>
            <van-cell title="Streak Days" :value="user.streak_days ? user.streak_days : 'N/A'"/>
        </van-cell-group>

        <van-cell-group inset>
            <van-button block plain round type="warning" :onclick="authStore.logout">
                Logout
            </van-button>
        </van-cell-group>
    </van-space>
</template>
